import { render } from "./temporary.vue?vue&type=template&id=778afb0f&scoped=true"
import script from "./temporary.vue?vue&type=script&lang=js"
export * from "./temporary.vue?vue&type=script&lang=js"

import "./temporary.vue?vue&type=style&index=0&id=778afb0f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-778afb0f"]])

export default __exports__